/**
 * Centralized angle and rotation constants.
 * These constants are reused across multiple modules for angle calculations,
 * rotations, and orientation-related operations.
 */

/** Epsilon for floating-point angle comparisons (most strict) */
export const ANGLE_EPSILON_STRICT = 1e-9;

/** Epsilon for floating-point angle comparisons (general purpose) */
export const ANGLE_EPSILON = 1e-8;

/** Epsilon for floating-point angle comparisons (loose) */
export const ANGLE_EPSILON_LOOSE = 1e-6;

/** Epsilon for general floating-point geometric calculations */
export const GEOMETRY_EPSILON = 1e-10;

/** Epsilon for capacity/dimension calculations */
export const CAPACITY_EPSILON = 1e-9;

/** General tolerance for numeric comparisons (0.001) */
export const NUMERIC_TOLERANCE = 0.001;

/** Quarter rotation in radians (90 degrees) */
export const QUARTER_ROTATION_RADIANS = Math.PI / 2;

/** Half rotation in radians (180 degrees) */
export const HALF_PI = Math.PI / 2;

/** Full rotation in radians (360 degrees) */
export const FULL_ROTATION_RADIANS = Math.PI * 2;

/** 45 degrees in radians */
export const ANGLE_45_DEGREES_RADIANS = Math.PI / 4;

/** Half rotation in radians (180 degrees) */
export const HALF_ROTATION_RADIANS = Math.PI;

/** 3/4 rotation in radians (270 degrees) */
export const THREE_QUARTER_ROTATION_RADIANS = (3 * Math.PI) / 2;

/** Minimum angle (0 degrees) in radians */
export const ANGLE_0_RADIANS = 0;

/** Maximum angle (360 degrees) in radians */
export const ANGLE_360_RADIANS = Math.PI * 2;

/** Tolerance for angle tolerance checks (0.1 degrees in radians) */
export const ANGLE_TOLERANCE_0_1_DEGREES = Math.PI / 1800;
